import React, { useState, useRef } from 'react';
import { Row, Col, Avatar } from 'antd';
import { titlize } from '../../utils/strings';
import './styles.css';

import { CommentInput } from './comment-input';

export function CommentBox({ onFocus, onChange, commenter, onSaveComment }: any) {
	const [loading, setLoading] = useState(false);
	let commentAreaRef = useRef<HTMLInputElement>(null);

	return (
		<Row>
			<Col xs={3} sm={2}>
				<Avatar
					size={32}
					src={commenter.avatar || null}
					shape="circle"
					style={{
						backgroundColor: commenter.avatarBgColor
					}}
				>
					<span style={{ mixBlendMode: 'difference' }}>{`${titlize(commenter.firstName[0])}${titlize(
						commenter.lastName[0]
					)}`}</span>
				</Avatar>
			</Col>

			<Col xs={21} sm={22}>
				<>
					<CommentInput
						disabled={loading}
						ref={commentAreaRef}
						onSave={(val, attachment, callback) => {
							setLoading(true);
							onSaveComment(val, attachment, err => {
								setLoading(false);
								callback(err);
							});
						}}
						loading={loading}
						richEditor
					/>
				</>
			</Col>
		</Row>
	);
}
